import i18n from '../../../translations/i18n';

export const computeDuration = (duration: string): string => {
  const splittedHour = duration?.split('T')[1]?.split('H');
  return i18n.t('common.relative-time.time', {
    hours: splittedHour[0],
    minute: splittedHour[1].split('M')[0],
  });
};
